import React, { Component } from 'react';
import Image from "react-graceful-image";
import './App.css'

import {
	Link
} from 'react-router-dom'

import ceiling_waves from './images/ceiling-waves.png'
import ceiling_waves_vinyl from './images/ceiling-waves-vinyl.png'

class HomePage extends Component {
	render() {
		return (
			<div className="App-content">
				<div className="Home-page-content">
					<Link to="/ceiling-waves">
						<Image noLazyLoad="true" src={ceiling_waves} className="Home-page-image" placeholderColor="#000"  alt="Ceiling Waves Album Art"/>
						<img noLazyLoad="true" src={ceiling_waves_vinyl} className="Home-page-image-mouseover"  alt="Ceiling Waves Vinyl"/>
					</Link>
				</div>
			</div>
			);
	}
}

export default HomePage;